import { FormsMultilineInput, Spinner } from '@platform/components';
import { Control, FormState } from 'react-hook-form';
import { UpdateDiscoveryCallFormData } from '.';

type OtherUpdateContentProps = {
  isSaving: boolean;
  children?: React.ReactNode;
  control: Control<UpdateDiscoveryCallFormData>;
  formState: FormState<UpdateDiscoveryCallFormData>;
};

export const OtherUpdateContent = (props: OtherUpdateContentProps) => {
  return (
    <div className='flex flex-col gap-4 md:mt-8 md:w-[500px]'>
      {props.isSaving ?
        <div className='flex justify-center'>
          <Spinner />
        </div>
      : <>
          {props.children ?
            props.children
          : <div className='text-center text-xl'>
              Let us know what's going on, and a real person from our team will follow up with you.
            </div>
          }
          <div className='mt-4 items-stretch'>
            <FormsMultilineInput
              control={props.control}
              name='otherUpdateDetails'
              placeholder="Let us know what's going on..."
              characterCount={500}
              rules={{ required: `Let us know what's going on to continue` }}
              formsError={props.formState.errors['otherUpdateDetails']}
            />
          </div>
        </>
      }
    </div>
  );
};
